<template>
    <NavBar :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'">
        <template v-slot:title>
            <span class="nav-title">个人中心</span>
        </template>
    </NavBar>
    <main :class="{ new_year_bg_color: $newYearStyle }">
        <header>
            <div class="user-info">
                <img src="@/assets/images/HeadPortrait.png" class="head"/>
                <section>
                    <p class="user-name">{{ user.name ? user.name : "未实名用户" }}</p>
                    <p class="phone">
                        {{
                            (user.mobile + "").replace(
                                /(\d{3})\d{4}(\d{4})/,
                                "$1****$2"
                            )
                        }}
                    </p>
                </section>
                <router-link to="/notice" class="horn">
                    <img src="@/assets/images/horn.png">
                </router-link>
            </div>
            <section class="scan" v-if="false">
                <img src="@/assets/images/scan.png" alt="" />
                <p>我的关注：{{ user.organizations_count }}</p>
            </section>
        </header>
        <div class="blockchain" v-if="user.bid">
            <span class="code ellipsis1">区块链地址：{{ user.bid }}</span>
            <span id="copy" :data-clipboard-text="user.bid" @click="copy">
                <img src="@/assets/images/copy.png" alt="" />
                复制
            </span>
        </div>
        <div class="navigation-bar">
            <div class="navigation-box">
                <router-link to="/entity" class="item">
                    <img src="@/assets/images/my-object.png" alt="" v-if="!$newYearStyle"/>
                    <img src="@/assets/images1/newYear/my-object.png" alt="" v-else/>
                    <p class="name">我的藏品</p>
                    <p class="num">{{ user.entities_count ? user.entities_count : 0 }}</p>
                </router-link>
                <router-link to="/order" class="item">
                    <img src="@/assets/images/my-order.png" alt="" v-if="!$newYearStyle"/>
                    <img src="@/assets/images1/newYear/my-order.png" alt="" v-else/>
                    <p class="name">我的订单</p>
                    <p class="num">{{ user.orders_count ? user.orders_count : 0 }}</p>
                </router-link>
                <router-link to="/delivery" class="item">
                    <img src="@/assets/images/my-gift.png" alt="" v-if="!$newYearStyle"/>
                    <img src="@/assets/images1/newYear/my-gift.png" alt="" v-else/>
                    <p class="name">心意投递</p>
                    <p class="num">{{ user.deliver_count ? user.deliver_count : 0 }}</p>
                </router-link>
                <router-link to="/subscribe" class="item">
                    <img src="@/assets/images/my-message.png" alt="" v-if="!$newYearStyle"/>
                    <img src="@/assets/images1/newYear/my-message.png" alt="" v-else/>
                    <p class="name">我的预约</p>
                    <p class="num">{{ user.subscribes_count ? user.subscribes_count : 0 }}</p>
                </router-link>
                <router-link to="/invitation" class="item">
                    <img src="@/assets/images/invitation.png" alt="" v-if="!$newYearStyle"/>
                    <img src="@/assets/images1/newYear/invitation.png" alt="" v-else/>
                    <p class="name">邀请好友</p>
                    <p class="num">{{ user.invitations_count ? user.invitations_count : 0 }}</p>
                </router-link>
            </div>
        </div>
        <div class="real-name" v-if="! user.name">
            <router-link to="/auth">
                <div class="real-box">
                    <section>
                        <img
                            class="my-icon"
                            src="@/assets/images/my-authentication.png"
                            alt=""
                        />
                        <span class="authentication">实名认证</span>
                    </section>
                    <section>
                        <span>未认证</span>
                        <van-icon name="arrow" color="#fff" size="14" />
                    </section>
                </div>
            </router-link>
        </div>
        <div class="button-box">
            <router-link to="/welfare" class="item">
                <img src="@/assets/images/equity.png" class="icon" v-if="!$newYearStyle">
                <img src="@/assets/images1/newYear/equity.png" class="icon" v-else>
                <p class="name">权益中心</p>
                <van-icon size="14" name="arrow" color="#363636" class="arrow"/>
            </router-link>
            <router-link to="/activity" class="item">
                <img src="@/assets/images/activity.png" class="icon" v-if="!$newYearStyle">
                <img src="@/assets/images1/newYear/activity.png" class="icon" v-else>
                <p class="name">活动专区</p>
                <van-icon size="14" name="arrow" color="#363636" class="arrow"/>
            </router-link>
        </div>
        <div class="information-bar">
            <ul>
                <!-- <a href="javascript:;" @click="giveShow = true">
                    <li>
                        <div class="title">
                            <img src="@/assets/images/my-record.png" alt="" />
                            <span>转赠记录</span>
                        </div>
                        <van-icon name="arrow" color="#343A40" size="14" />
                    </li>
                </a> -->
                <!-- <a href="javascript:;" @click="serviceShow = true">
                    <li>
                        <div class="title">
                            <img src="@/assets/images/my-service.png" alt="" />
                            <span>我的客服</span>
                        </div>
                        <van-icon name="arrow" color="#343A40" size="14" />
                    </li>
                </a> -->
                <router-link to="/about">
                    <li>
                        <div class="title">
                            <img src="@/assets/images/my-about.png" alt="" v-if="!$newYearStyle"/>
                            <img src="@/assets/images1/newYear/my-about.png" alt="" v-else/>
                            <span>关于我们</span>
                        </div>
                        <van-icon name="arrow" color="#343A40" size="14" />
                    </li>
                </router-link>
                <a href="javascript:;" @click="shareShow = true">
                    <li>
                        <div class="title">
                            <img src="@/assets/images/my-share.png" alt="" v-if="!$newYearStyle"/>
                            <img src="@/assets/images1/newYear/my-share.png" alt="" v-else/>
                            <span>分享</span>
                        </div>
                        <van-icon name="arrow" color="#343A40" size="14" />
                    </li>
                </a>
            </ul>
        </div>
    </main>
    <Poster @ready="posterReady"></Poster>
    <van-overlay :show="shareShow" class="share">
        <img :src="posterBase64" alt="" class="poster" @touchstart="touchStart" @touchend="touchEnd" ref="poster">
        <p class="tip">长按图片保存到本地</p>
        <img src="@/assets/images/close.png" alt="" class="close" @click="shareShow = false">
    </van-overlay>

    <div class="service-pop" v-if="serviceShow" @click="serviceShow = false">
        <div class="box">
            <div class="close"></div>
            <div class="title">
                <p>扫描下方二维码</p>
                <p>联系客服</p>
            </div>
            <img class="er-code" src="@/assets/images/service-qrcode.jpg" alt="" />
            <span class="btn" @click="serviceShow = false">好的</span>
        </div>
    </div>

    <div class="login" v-if="giveShow">
        <div class="succ-box">
            <div class="close" @click="giveShow = false"></div>
            <div class="words">
                <div>
                    <p style="line-height: 26px">暂未开通</p>
                </div>
            </div>
            <div class="is-btn btn-go-login">
                <div class="btn_left" @click="giveShow = false">好的</div>
                <!-- <div class="btn_right">确认合成</div> -->
            </div>
        </div>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>